import { useFeatureFlags } from './useFeatureFlags';
import { useUserDirectoryLocationInformationFilters } from './useLocationInformationFilters';
import { useQualificationFilters } from './useQualificationFilters';
export function useExtendedCredentialingUserDirectoryFilters() {
    const { tribe: tribeEnabled, skillsAndTrainings: skillsAndTrainingEnabled } = useFeatureFlags();
    const { locationFilters } = useUserDirectoryLocationInformationFilters();
    const { qualificationFilters } = useQualificationFilters();
    const extendCredentialingFilters = (builder, options) => {
        if (tribeEnabled) {
            locationFilters(builder, options === null || options === void 0 ? void 0 : options.regionEnabled);
        }
        if (skillsAndTrainingEnabled) {
            qualificationFilters(builder);
        }
    };
    return {
        extendCredentialingFilters,
    };
}
